module.exports = __webpack_public_path__ + "static/media/Databaseimage.4873bd09.png";